import api from './api';

export interface AgentTool {
  name: string;
  description: string;
}

export const toolsService = {
  async list(): Promise<AgentTool[]> {
    const response = await api.get<{ data: AgentTool[] }>('/tools');
    return response.data.data;
  },
};
